export default __webpack_public_path__ + "static/media/ISMO SYLLABUS_2026-27 CLASS 10.eea659ea.pdf";